@if (isGeolocationView()) {
  <section class="register-user__geolocation-request">
    <main class="geolocation-request__main">
      <img 
        class="geolocation-request__icon"
        src="/assets/imgs/register-user-geolocation-icon.svg" 
        [alt]="'Icono de geolocalización' | translate"
      >
      
      <hgroup class="geolocation-request__title-wrapper">
        <h3 class="geolocation-request__title ci-heading-h3-s-bold">
          ¿{{ 'Quieres seguir tu ruta en tiempo real' | translate }}?
        </h3>
        <p class="ci-paragraph-p1-regular geolocation-request__helper-text">
          {{ 'Para poder seguir tu ruta en tiempo real solicitaremos los permisos de geolocalización. En caso de no aceptarlos, se realizará una navegación paso a paso' | translate }}
        </p>
        <p class="ci-paragraph-p1-regular geolocation-request__helper-text">
          <strong>
            {{ 'Esta acción es necesaria para actividades de gamificación' | translate }}
          </strong>
        </p>
      </hgroup>
    </main>

    <footer class="register-user__geolocation-footer">
      <ci-button
        [class-name]="'ci-btn-primary-s-filled'"
        class="geolocation-footer__next-button"
        (click)="handleRequestGeolocation(true)"
      >
        {{ 'Solicitar geolocalización' | translate }}
      </ci-button>
      
      <ci-text-button
        class-name="ci-text-btn-primary-s"
        class="geolocation-footer__prev-button"
        (click)="handleRequestGeolocation(false)"
      >
        {{ 'No me interesa' | translate }}
      </ci-text-button>
    </footer>  
  </section>
}